import { render } from "./adminpageView.vue?vue&type=template&id=08945ab6&scoped=true"
import script from "./adminpageView.vue?vue&type=script&lang=js"
export * from "./adminpageView.vue?vue&type=script&lang=js"

import "./adminpageView.vue?vue&type=style&index=0&id=08945ab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08945ab6"]])

export default __exports__